export default {
    spaceId: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN,
};

